import { SelfDrivingService } from "../../server/api/self-driving";
import { toSlug } from "../../utils/create-slug";

export async function getToneText(
  tone: "professional" | "casual" | "direct" | "custom",
  toneSummary: string,
  {
    format,
    description,
    fileId,
    salutation,
    signOff,
  }: {
    format: string;
    description: string;
    fileId?: string;
    salutation?: string;
    signOff?: string;
  },
  token: string,
): Promise<{ data: { text: string }; error: null } | { data: null; error: Error }> {
  const service = new SelfDrivingService(token);
  const formatId = toSlug(format).replace(/-/g, "_");
  const response = await service.text(
    formatId,
    description,
    toneSummary,
    tone,
    fileId,
    salutation,
    signOff,
  );

  if (response?.error || !response.data) {
    return { data: null, error: new Error(response.error) };
  }

  return { data: response.data, error: null };
}
